import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { TransporterUpdateDocumentModel } from './../../../../models/archive/transporter-update-document.model';
import { TransporterModel } from './../../../../models/archive/transporter.model';
import { TransporterService } from './../../../../services/archive/transporter.service';

@Component({
  selector: 'app-update-document-transporter',
  templateUrl: './update-document-transporter.component.html',
  styleUrls: ['./update-document-transporter.component.scss'],
  standalone: false
})
export class UpdateDocumentTransporterComponent implements OnInit {

  changeDocument: boolean = false;
  formTransporterUpdate: FormGroup = new FormGroup({});
  transporterModel: TransporterModel = new TransporterModel();
  subscription: Subscription;

  constructor(private transporterService: TransporterService,
    public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm(new TransporterModel());
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.transporterModel = inputs.transporterContract;
      if (this.transporterModel) {
        this.validateForm(this.transporterModel);
      } else {
        console.warn('transporterModel undefined');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.changeDocument) {
      data.params = { reload: true, transporterModel: this.transporterModel };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  async getDigitVerification() {
    const document = this.formTransporterUpdate.get("document")?.value;
    if (document == '') {
      this.formTransporterUpdate.controls["digitVerification"].patchValue(null);
      this.toastHandlerService.showToast(
        'error',
        `El documento ingresado no es válido.`
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.transporterService.getDigitVerification(document));
      this.formTransporterUpdate.controls["digitVerification"].patchValue(response);
    } catch (error) {
      this.formTransporterUpdate.controls["digitVerification"].patchValue(null);
      console.error('Error al modificar el transportador.', error);
    }
  }

  async send() {
    this.validateFormControls();
    if (this.formTransporterUpdate.valid) {
      const modelTransporter = this.formTransporterUpdate.getRawValue() as TransporterUpdateDocumentModel;
      try {
        this.transporterModel = await firstValueFrom(
          this.transporterService.updateTransporterDocument(modelTransporter)
        );
        this.validateForm(this.transporterModel);
        this.changeDocument = true;
        this.close();
        this.toastHandlerService.showToast(
          'success',
          `El documento del transportador fue modificado exitosamente.`
        );
      } catch (error) {
        console.error('Error al modificar el transportador.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      transporterId: {
        required: 'El campo Transportador es obligatorio.',
        min: 'Debe seleccionar un Transportador válido.'
      },
      document: {
        required: 'El campo Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El campo Dígito de Verificación es obligatorio.',
        min: 'El Dígito de Verificación no puede ser menor que 0.',
        max: 'El Dígito de Verificación no puede ser mayor que 9.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formTransporterUpdate.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm(transporterModel: TransporterModel) {
    this.formTransporterUpdate = this.formBuilder.group({
      transporterId: [transporterModel.transporterId, [Validators.required, Validators.min(1)]],
      document: [transporterModel.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [transporterModel.digitVerification, [Validators.required, Validators.min(0),
      Validators.max(9)]]
    });
    setTimeout(() => this.formTransporterUpdate.controls["digitVerification"].disable());
  }

  validateFormControls() {
    Object.keys(this.formTransporterUpdate.controls).forEach((key) => {
      const control = this.formTransporterUpdate.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
